import axios from "axios";

const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080/api";
  if (typeof window !== "undefined" && window.location) {
    if (envUrl.startsWith("http://") || envUrl.startsWith("https://")) {
      try {
        const parsed = new URL(envUrl);
        if ((parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1") && window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
          return `${window.location.protocol}//${window.location.hostname}:${parsed.port || "8080"}${parsed.pathname}`;
        }
      } catch (e) {}
    }
  }
  return envUrl;
};

const ApiClient = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

// Direct public access - no authentication token required
ApiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.error("API call error:", error);
    return Promise.reject(error);
  }
);

export default ApiClient;
